// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeliveryNoteStatus from "../../../../../../../../library/data-source/order/entity/DeliveryNoteStatus.bs.js";

function getVm(order) {
  var data = order._0.delivery_note;
  if (data === undefined) {
    return {
            is_requested: "False",
            status: "N/A"
          };
  }
  var value = data.hardcopy_status;
  var tmp;
  if (value !== undefined) {
    tmp = DeliveryNoteStatus.toString(value);
  } else {
    var value$1 = data.softcopy_status;
    tmp = value$1 !== undefined ? DeliveryNoteStatus.toString(value$1) : "N/A";
  }
  return {
          is_requested: "True",
          status: tmp
        };
}

export {
  getVm ,
  
}
/* No side effect */
